<template>
  <div
    class="shadow"
    :class="{'border-top': active}"
  >
    <div class="help">
      <div class="help-on">
        <h2>Crystal Structure Ligand</h2>
        <v-row>
          Explore the SILCS FragMap for Factor Xa. The crystal structure is
          also displayed. Toggle the generic
          FragMap types "on" and "off" to see where these groups interact
          most favorably with the protein surface. Overlap between the
          FragMap densities and the crystallographic ligand can be
          observed. The overlap of FragMap densities and ligand moiety
          suggests the moiety should be kept during the lead optimization
          process. Adding an R-group towards the unoccupied densities could
          improve the binding affinity of the compound.
        </v-row>
      </div>
    </div>
    <div class="navigation">
      <template v-if="active">
        <i
          class="el-icon-circle-close close"
          @click="toggle"
        />
      </template>
      <template v-else="active">
        <v-row
          class="open"
          @click="toggle"
        >
          <i class="el-icon-information" />
          Help
        </v-row>
      </template>
    </div>
  </div>
</template>

<script>
  // import Marked from 'marked'
  // let renderer = new Marked.Renderer()

  // Marked.setOptions({
  //   renderer: renderer,
  //   sanitize: true
  // })

  export default {
    name: 'Ligandhelp',
    data () {
      return {
        active: true,
      }
    },
    computed: {
    },
    methods: {
      toggle: function () {
        this.active = !this.active
      },
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
